import MembershipBusinessModelBase from '../_generated/modelBases/membership-business-model-base';

export default class MembershipBusinessModel extends MembershipBusinessModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
